import IconButton from './IconButton';

export default IconButton;
export * as IconButtonStyles from './IconButton.styles';
export * as IconButtonTypes from './IconButton.types';
